export default {
    "title": "趣头条亮相长三角文博会，助力“互联网+文化”新业态发展",
    "time": "2020-11-20",
    "source": "中新经纬",
    "origin": "http://www.jwview.com/jingwei/11-20/362753.shtml",
    "content": `<p>　　中新经纬客户端11月20日电 第三届长三角国际文化产业博览会于11月19日在国家会展中心(上海)拉开帷幕。这是在疫情冲击下长三角文化产业重启繁荣的展台，也是新基建、新经济发展命题下培育“互联网+文化”新业态的集中体现。作为本届文博会特邀企业，趣头条携旗下产品趣头条App和米读App首次参展，展现互联网时代下文化新经济的发展成果。</p>
    
    <p>　　长三角文博会由沪苏浙皖党委宣传部联合举办，是贯彻长三角高质量一体化发展国家战略、落实《长江三角洲区域一体化发展规划纲要》的重要举措，也是推动长三角文化产业协同发展的重要平台。</p>
    
    <div style="text-align:center"><img style="border:px solid #000000" src="http://i2.chinanews.com/simg/cmshd/2020/11/20/626ddac47c78430e8f5e7bff8b7409f2.jpg" alt=""></div>
    
    <p>　　在本次展会中，趣头条精心布展，并巧妙设计了互动专区，通过对智能技术的充分运用，全面呈现了趣头条产品发展历程和核心理念，体现出科技赋能时代下，趣头条对新生代网民文化需求的重视与洞察。</p>
    
    <p>　　趣头条App于2016年正式上线，首创了游戏化的积分运营机制，以娱乐、生活资讯为主体内容，依托于智能化数据分析系统，为三线及以下城市新兴市场受众提供精准的内容分发服务，有效培育了新兴市场用户的阅读习惯。凭借这款产品的迅猛发展，趣头条公司在成立27个月后，便成功登陆纳斯达克，成为中国移动内容聚合第一股，创下当时中概股最快上市纪录，并凭借业务的快速发展和持续创新荣获2020年中国互联网百强企业第23名。</p>
    
    <p>　　趣头条旗下的网络文学产品“米读”同样是网文领域的黑马，它首创“免费+广告”模式，自2018年诞生起迅速带动数字阅读市场的繁荣发展。在迈过流量抢夺的1.0时代后，米读在原创和独家内容耕耘上也领先同行，在今年4月率先推出“平民英雄”作者扶持计划，斥资10亿元资金及流量培养潜力作者，在孵化出一批点击破亿、粉丝数破百万顶级作品的同时，更是发掘、培养了一批优质潜力作者，为其提供了重要营收来源，目前作者单月最高收入已破50万元。此外，米读成功开拓了IP短剧孵化的创新模式，并在今年9月与快手达成战略合作，目前已完成的十余部短剧，在快手上累计播放次数已超12亿次。</p>
    
    <div style="text-align:center"><img style="border:px solid #000000" src="http://i2.chinanews.com/simg/cmshd/2020/11/20/47bc00c1400541c682cb1a667425748f.jpg" alt=""></div>
    
    <p>　　同时，作为一家新兴的互联网企业，趣头条始终不忘所承担的企业社会责任，趣头条充分发挥内容平台的优势，在2020年5月启动了“趣助农”计划，让亿级用户参与到公益助农活动中，为贫困县的特产销售、文化传承、旅游发展提供帮助。</p>
    
    <p>　　其中，“佳核万事兴”是趣头条与云南省楚雄州武定县共同发起的公益助农项目。今年5-9月，趣头条以“游戏+电商”的扶贫新模式促进云南滞销核桃销售，在弘扬正能量的同时，推动在线新经济的进一步释放。</p>
    
    <p>　　文化内容是大众生活中的刚需，互联网则为文化消费提供了更多渠道和内容空间想象。在“互联网+文化”产业新形态的探索中，趣头条始终以“通过内容为用户带来乐趣”为使命，未来也将继续巩固技术优势，打造全球领先的线上内容生态，推动新兴市场用户的精神文明建设不断丰富。</p>`
}